import React from 'react';
import TextFilter from './TextFilter';
import SelectFilter from './SelectFilter';
import { Button, Container, Row, Col } from 'react-bootstrap'
import { minusIcon, searchIcon } from "../../../img/font_awesome/font_awesome"

export default class PageBanner extends React.Component {
   render() {
   
      let textFilterComponent = '';
      if (this.props.textFilterProps && this.props.textFilterProps.filterText) {
         textFilterComponent =<><span> <Button variant="secondary" onClick={this.props.textFilterProps.textFilterReset}>{minusIcon} {this.props.textFilterProps.filterText}</Button></span></>   
      } else if (this.props.textFilterProps) {
         textFilterComponent =  <span style={{ display:'inline-block', marginLeft: 20 }}><TextFilter textFilterProps={this.props.textFilterProps}></TextFilter></span>
      } 

      let selectFilterComponent = '';
      if (this.props.selectFilterProps) {
         selectFilterComponent = <span style={{ display:'inline-block', marginLeft: 20 }}><SelectFilter selectFilterProps={this.props.selectFilterProps}></SelectFilter></span>
      }

      let finderFilterComponent = '';
      if (this.props.finderFilterProps && this.props.finderFilterProps.id > 0) {
         finderFilterComponent =<><span> <Button variant="secondary" onClick={this.props.finderFilterProps.finderFilterReset}>{minusIcon} {this.props.finderFilterProps.name}</Button></span></>   
      } else if (this.props.finderFilterProps) {
         finderFilterComponent = <span style={{ display:'inline-block'}}>
            <Container style={{ paddingRight: 0}} >
               <Row>
                  <Col><Button className='btn-outline-primary' onClick={this.props.finderFilterProps.finderFilterClick}>Email Address {searchIcon}</Button></Col>
               </Row>
            </Container>
         </span> 
      }

      let finderFilterComponent2 = '';
      if (this.props.finderFilterProps2 && this.props.finderFilterProps2.id > 0) {
         finderFilterComponent2 =<><span> <Button variant="secondary" onClick={this.props.finderFilterProps2.finderFilterReset}>{minusIcon} {this.props.finderFilterProps2.name}</Button></span></>   
      } else if (this.props.finderFilterProps2) {
         finderFilterComponent2 = <span style={{ display:'inline-block'}}>
            <Container style={{ paddingRight: 0}} >
               <Row>
                  <Col><Button className='btn-outline-primary' onClick={this.props.finderFilterProps2.finderFilterClick}>Phone {searchIcon}</Button></Col>
               </Row>
            </Container>
         </span> 
      }

      let finderFilterComponent3 = '';
      if (this.props.finderFilterProps3 && this.props.finderFilterProps3.id > 0) {
         finderFilterComponent3 =<><span> <Button variant="secondary" onClick={this.props.finderFilterProps3.finderFilterReset}>{minusIcon} {this.props.finderFilterProps3.name}</Button></span></>   
      } else if (this.props.finderFilterProps3) {
         finderFilterComponent3 = <span style={{ display:'inline-block'}}>
            <Container style={{ paddingRight: 0}} >
               <Row>
                  <Col><Button className='btn-outline-primary' onClick={this.props.finderFilterProps3.finderFilterClick}>User {searchIcon}</Button></Col>
               </Row>
            </Container>
         </span> 
      }

      let criteriaList = '';
      if (this.props.searchCriteria) {
         criteriaList = this.props.searchCriteria.map(criteria => {
            return <ul style={{ display: 'inline-block', marginBottom: 0, listStyleType: 'none', paddingLeft:10, fontSize: 14 }}><li style={{ textDecoration: "underline" }} >{ criteria.description}</li><li style={{ textAlign: "center" }}>{criteria.value}</li></ul>
         });
      }
   
      let buttonList = '';
      if (this.props.buttons) {
         buttonList = this.props.buttons.map((button) => {
            let buttonClassName = button.className;
            if (!buttonClassName) {
               buttonClassName = "btn btn-primary";
            }
            return (<><button className={buttonClassName} onClick={button.onClickAction} >{button.icon} {button.label}</button>&nbsp;</>)
         })
      }

      // let standoutButton = 

      return (
         <h5 style={{ backgroundColor: 'antiqueWhite', color: '#145A7B', paddingTop: 10, paddingBottom: 10, paddingLeft: 10, marginTop: 5, marginLeft:4, marginRight:4 }}>
            {this.props.pageHeading}
            {textFilterComponent}
            {selectFilterComponent}
            {finderFilterComponent}
            {finderFilterComponent2}
            {finderFilterComponent3}
            <span style={{ marginRight: 20 }}>{criteriaList}</span>
            <span style={{ float: 'right', marginRight: 10 }}>{buttonList}</span>
         </h5>
      )
   }

}